function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 2.10003C15.4 1.40003 14.9 0.900025 14.2 0.700025C13 0.400025 7.89999 0.400024 7.89999 0.400024C7.89999 0.400024 2.90001 0.400025 1.60001 0.700025C0.900006 0.900025 0.399997 1.40003 0.199997 2.10003C-3.05474e-06 3.40003 0 6.00002 0 6.00002C0 6.00002 3.03984e-06 8.60002 0.300003 9.90002C0.500003 10.6 0.999997 11.1 1.7 11.3C2.9 11.6 8 11.6 8 11.6C8 11.6 13 11.6 14.3 11.3C15 11.1 15.5 10.6 15.7 9.90002C16 8.60002 16 6.00002 16 6.00002C16 6.00002 16 3.40003 15.6 2.10003ZM6.39999 8.40002V3.60003L10.6 6.00002L6.39999 8.40002Z",
  fill: "white"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c839a42b.svg";
export { ForwardRef as ReactComponent };